import styled from 'styled-components';
import Modal from 'components/common/Modal';
import { useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import pdf from 'assets/user_agreement.pdf';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

const UserAgreementModal = ({ onClose }) => {
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };

  return (
    <StyledModal closeModal={onClose}>
      <div>
        <Document file={pdf} onLoadSuccess={onDocumentLoadSuccess}>
          <Page pageNumber={pageNumber} />
        </Document>
        <div className="user-agreement-modal-footer">
          <p>
            Page {pageNumber} of {numPages}
          </p>
          {pageNumber > 1 && (
            <button onClick={() => setPageNumber(prev => prev + -1)}>
              이전페이지
            </button>
          )}
          {pageNumber < numPages && (
            <button onClick={() => setPageNumber(prev => prev + +1)}>
              다음페이지
            </button>
          )}
        </div>
      </div>
    </StyledModal>
  );
};

export default UserAgreementModal;

const StyledModal = styled(Modal)`
  max-height: 750px;

  .user-agreement-modal-footer {
    display: flex;
    padding: 0 50px;
    justify-content: space-between;
    align-items: center;
  }
`;
